import { render, staticRenderFns } from "./PdfPlayerModal.vue?vue&type=template&id=45dcc618&scoped=true&"
import script from "./PdfPlayerModal.vue?vue&type=script&lang=js&"
export * from "./PdfPlayerModal.vue?vue&type=script&lang=js&"
import style0 from "./PdfPlayerModal.vue?vue&type=style&index=0&id=45dcc618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dcc618",
  null
  
)

export default component.exports